import { ReactNode } from 'react'
import Icon from '../icon/Icon'
import s from './style.module.scss'

interface ISuffix {
  children?: ReactNode
  suffix?: string
}

const Suffix = ({ children, suffix }: ISuffix) => (
  <span className={s.suffix}>
    {children}
    {suffix && <Icon name={suffix} mui />}
  </span>
)

export default Suffix
